module.exports = __webpack_public_path__ + "img/11_62.2b7537c4.png";